(function () {
    angular.module('components.navigation', [
        'ngResource',
        'utility'
    ])
        .factory('navigationService', navigationService)
        .directive('topBar', topBar)
        .directive('accordionNav', accordionNav)
        .directive('multiNav', multiNav)
        .directive('activeClass', activeClass);

    navigationService.$inject = ['$q', '$timeout', '$resource'];
    function navigationService($q, $timeout, $resource) {
        var base = '/api/main/'
        return {
            api: {
                primary: $resource(base + 'primary-nav', {}, {
                    query: {
                        cache: true,
                        isArray: true
                    }
                })
            }
        }
    }

    topBar.$inject = ['navigationService'];
    function topBar(navigationService) {
        var directive = {
            replace: true,
            restrict: 'E',
            templateUrl: '/angular/components/navigation/topBar.html'
        }
        return directive;
        function link(scope, element, attrs) {
            scope.links = navigationService.api.main.get();
            scope.openNav = function () {

            }
        }
    }

    accordionNav.$inject = ['navigationService'];
    function accordionNav(navigationService) {
        var directive = {
            replace: true,
            templateUrl: '/angular/components/navigation/accordionNav.html',
            scope: {
                links: '=?'
            },
            link: link
        };
        return directive;
        function link(scope, element, attrs) {
            if (!scope.links)
                scope.links = navigationService.api.primary.query();
        }
    }

    multiNav.$inject = ['navigationService', '$timeout', '$window'];
    function multiNav(navigationService, $timeout, $window) {
        var directive = {
            replace: true,
            restrict: 'E',
            scope: {
                links: '=?',
                rootId: '=',
                autoSize: '=?',
                maxLevel: '=?',
                onReady: '&?'
            },
            //templateUrl: '/angular/components/navigation/multiNav.html',
            template: `
                <ul class="multi-nav grid-x small-up-1" ng-class="{'auto-size': autoSize}">
                    <li class="cell level-1 level" ng-style="shift">
                        <ul>
                            <li ng-repeat="link in links|filter:{styles: '!extra-link'}" ng-class ="{expanded: link.expanded}" class="level-2">
                                <div class="link-container">
                                    <span ng-if="link.children.length > 0" class ="fa fa-minus" ng-click="handleClick($event, link, 1)"></span>
                                    <a ng-if="link.children.length > 0" ng-click="handleClick($event, link, 1)" ng-class ="{active: link.id === levels[0].id}">{{link.name}}</a>
                                    <a ng-if="!link.children.length" ng-href="{{link.url}}" ng-click="handleClick($event, link, 1)" ng-class ="{active: link.id === levels[0].id}">{{link.name}}</a>
                                </div>
                                <ul ng-if="link.children.length > 0" class="level-2-menu">
                                    <li class ="standard"><a class ="current" ng-href="{{link.url}}">Overview</a></li>
                                    <li ng-repeat="subLink in link.children" ng-class ="{'has-children' : subLink.children.length > 0, expanded: subLink.expanded}" class ="level-3">
                                        <div class="link-container">
                                            <span ng-if="subLink.children.length > 0" class ="fa fa-minus" ng-click="handleClick($event, subLink, 1)"></span>
                                            <a ng-if="subLink.children.length > 0" ng-click="handleClick($event, subLink, 2)" ng-class ="{active: subLink.id === levels[1].id}">{{subLink.name}}</a>
                                            <a ng-if="!subLink.children.length" ng-click="handleClick($event, subLink, 2)" ng-href="{{subLink.url}}">{{subLink.name}}</a>
                                        </div>
                                        <ul ng-if="subLink.children.length > 0" class="level-3-menu">
                                            <li class ="standard"><a class ="current" ng-href="{{subLink.url}}">Overview</a></li>
                                            <li ng-repeat="subLink2 in subLink.children" ng-class ="{'has-children' : subLink2.children.length > 0}" class ="level-4">
                                                <a ng-if="!subLink2.children.length" ng-click="handleClick($event, subLink2, 3)" ng-href="{{subLink2.url}}">{{subLink2.name}}</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <br ng-if="(links|filter:{styles: 'extra-link'}).length" />
                        <ul class="top-links">
                            <li ng-repeat="link in links|filter:{styles: 'extra-link'}" ng-class="link.styles">
                                <a ng-href="{{link.url}}" ng-class ="{active: link.id === levels[0].id}">{{link.name}}</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            `,
            link: link
        };
        return directive;
        function link(scope, element, attrs) {
            var currentLevel;
            if (!scope.service)
                scope.links = navigationService.api.primary.query({ rootId: scope.rootId, maxLevel: scope.maxLevel || 3 }, function (data) {
                    $timeout(function () {
                        reset();
                        if (scope.onReady) {
                            scope.onReady({ data: data });
                        }
                    });
                });
            function reset() {
                scope.levels = [];
                currentLevel = 0;
                updateTransform();
            }
            function updateTransform() {
                var size = '-' + currentLevel + '00%';
                if (scope.autoSize && Foundation.MediaQuery.current !== 'small') {
                    var levels = angular.element('.level');
                    var totalWidth = 0;
                    for (var i = 0; i <= currentLevel; i++) {
                        totalWidth += angular.element(levels[i]).width();
                    }
                    size = (element.width() - totalWidth) + 'px';
                }
                scope.shift = {
                    'margin-left': size
                };
            }
            scope.handleClick = function ($event, link, level) {
                //if (link.children !== undefined && link.children.length > 0 && (scope.levels.length === 0 || link.id !== scope.levels[currentLevel - 1].id)) {
                if (link.children !== undefined && link.children.length > 0) {
                    $event.preventDefault();
                    /*if (scope.levels.length > level) {
                        console.log(scope.levels.length, level);
                        scope.levels = scope.levels.slice(0, level);
                        currentLevel = level;
                    }
                    scope.levels.push(link);
                    currentLevel++;
                    //$timeout(updateTransform);*/
                    scope.levels.push(link);
                    currentLevel++;
                    var element = angular.element(event.srcElement || event.target);
                    var parentLI = element.closest('li');
                    var parentDiv = element.parent();
                    var ul = null;
                    
                    console.log(scope.levels);

                    if (level == 1) {
                        
                        animateMenu(link, parentDiv);
                        ul = parentLI.find('ul.level-2-menu');
                        link.expanded = !(link.expanded != null && link.expanded);
                    }
                    else if (level == 2) {
                        animateMenu(link, parentDiv);
                        ul = parentLI.find('ul.level-3-menu');
                        link.expanded = !(link.expanded != null && link.expanded);
                    }
                    if (ul != null) {
                        ul.slideToggle();
                    }
                }
                else {
                    reset();
                }
            }

            function animateMenu(link, parentDiv) {
                if (!link.expanded) {
                    var tween = new TimelineMax()
                        .to(parentDiv.find('> a'), 0.25, { x: 15, ease: Power4.easeIn })
                        .to(parentDiv.find('> span'), 0.25, { startAt: { width: 0 }, width: 34, opacity: 1, display: 'inline-block' })

                }
                else {
                    var tween = new TimelineMax()
                        .to(parentDiv.find('> a'), 0.25, { x: 0, ease: Power4.easeIn })
                        .to(parentDiv.find('> span'), 0.25, { width: 0, opacity: 0, display: 'none' })
                }
            }

            scope.$root.$watch('dropdownOpen', function (val) {
                if (!val) {
                    reset();
                }
            });

            var win = angular.element($window).on('resize.multiNav', updateTransform);

            scope.$on('$destroy', function () {
                win.off('resize.multiNav');
            })

            scope.back = function () {
                scope.levels.pop();
                currentLevel--;
                updateTransform();
            }
        }
    }

    function activeClass() {
        var directive = {
            restrict: 'A',
            link: link
        };
        return directive;
        function link(scope, element, attrs) {
            var cl = attrs.activeClass;
            var path = attrs.ngHref || attrs.href;
            if (location.pathname.indexOf(path) === 0)
                element.addClass('active');
            else
                element.removeClass('active');
        }
    }
})();